import { AuthenticationResponse } from '~/common/entities/Authentication/AuthenticationRespsone';
import { AuthenticationRequest } from '~/common/entities/Authentication/AuthenticationRequest';
import { ApiErrorCallback, ApiSuccessCallback } from './callback';
import { createContainer } from 'unstated-next';
import { Api } from '~/common/api/common/api';
// import * as storage from 'electron-json-storage';
import { useEffect, useState } from 'react';
import axios, { AxiosError } from 'axios';

function useAuthentication() {
  const [authenticationState, setAuthenticationState] =
    useState<AuthenticationResponse>();
  const [error, setError] = useState<AxiosError<any> | undefined>();
  const [loading, setLoading] = useState(false);
  const login =
    (
      onSuccess?: ApiSuccessCallback<AuthenticationResponse>,
      onError?: ApiErrorCallback,
    ) =>
    async (values: AuthenticationRequest) => {
      const { data, error: ApiError } = await Api.post<
        AuthenticationResponse,
        AuthenticationRequest
      >('/auth/login/', values);
      setError(ApiError);
      setAuthenticationState(data);
      if (error && onError) {
        Api.logout();
        onError(error);
      }
      if (data && onSuccess) {
        onSuccess(data);
        Api.authenticate(data.token);
      }
      if (data) {
        localStorage.setItem('authenticationStateV2', JSON.stringify(data));
      }
    };

  useEffect(() => {
    if (authenticationState?.token) {
      Api.authenticate(authenticationState.token);
    } else {
      Api.logout();
    }
  }, [authenticationState?.token]);

  const logout = async () => {
    await axios.post('/auth/logout/').catch((err) => {
      console.warn(
        'Unable to send logout request. Logging user out anyway but here is the error nontheless: ',
        err,
      );
    });
    setAuthenticationState(undefined);
    localStorage.removeItem('authenticationStateV2');
    setLoading(false);
  };
  const loadFromStorage = () => {
    if (localStorage.getItem('authenticationStateV2')) {
      setLoading(true);
      const authState = JSON.parse(
        localStorage.getItem('authenticationStateV2') ?? '',
      ) as AuthenticationResponse;
      setAuthenticationState(authState);
      setLoading(false);
    }
  };
  return {
    authenticationState,
    error,
    login,
    logout,
    loadFromStorage,
    loading,
  };
}

export const {
  Provider: AuthenticationProvider,
  useContainer: useAuthenticationService,
} = createContainer(useAuthentication);
